module.exports = __webpack_public_path__ + "expand-ic-white.svg?152487d1c7fefd78f4c834f546c88520";